import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { APP_LINKS, imgSrc, imgSrcset } from "@/data/content";

export default function JoinBanner() {
  return (
    <section className="relative py-16 md:py-24" data-testid="join-banner">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl border border-gold/30" data-testid="join-banner-panel">
            <img src={imgSrc("venue", 800)} srcSet={imgSrcset("venue")} sizes="100vw" width={1600} height={2000} alt="" className="absolute inset-0 h-full w-full object-cover" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-r from-night via-night/90 to-night/60" />
            <div className="grain absolute inset-0" aria-hidden="true" />
            <div className="relative z-10 flex flex-col items-start gap-8 px-8 py-14 sm:px-12 lg:px-16 lg:py-20">
              <span className="eyebrow">Rejoignez-nous</span>
              <h2 className="max-w-2xl font-heading text-3xl font-extrabold uppercase tracking-tight text-foreground sm:text-4xl lg:text-5xl">
                Votre réseau. <span className="text-gold-grad">Votre passion.</span> Votre club.
              </h2>
              <div className="flex flex-col gap-4 sm:flex-row">
                <a
                  href={APP_LINKS.joinClub}
                  data-testid="join-banner-member-cta"
                  className="btn-sheen inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-gold-deep via-gold to-gold-hover px-8 py-4 text-sm font-bold uppercase tracking-[0.14em] text-night transition-transform duration-300 hover:scale-[1.04]"
                >
                  Rejoindre le club <ArrowRight className="h-4 w-4" />
                </a>
                <Link
                  to="/contact"
                  data-testid="join-banner-contact-cta"
                  className="inline-flex items-center justify-center rounded-full border border-white/30 px-8 py-4 text-sm font-bold uppercase tracking-[0.14em] text-white transition-all duration-300 hover:border-gold hover:text-gold"
                >
                  Nous contacter
                </Link>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
